{
  "time.nav": "Time",
  "time.reports.nav": "Reports",
  "time.duration.hoursMinutes": "{hours, number}h {minutes, number}m",
  "time.duration.hours": "{hours, number}h",
  "time.duration.minutes": "{minutes, number}m",
  "time.timer.start": "Start timer",
  "time.timer.stop": "Stop timer",
  "time.timer.startNamed": "Start timing {title}",
  "time.timer.stopNamed": "Stop timing {title}",
  "time.timer.runningOn": "Timer running on {title}",
  "time.timer.stopped": "Logged {duration} on {title}",
  "time.bar.title": "Start a timer",
  "time.bar.placeholder": "What are you working on?",
  "time.bar.loading": "Loading your tasks…",
  "time.bar.target": "Task or project",
  "time.bar.notePlaceholder": "Note (optional)",
  "time.bar.runningTitle": "Timer running",
  "time.target.projectWork": "Project work",
  "time.target.projectWorkOn": "Project work: {name}",
  "time.target.search": "Search tasks and projects",
  "time.target.empty": "No matching task or project",
  "time.form.duration": "Time spent",
  "time.form.durationHint": "1:30, 90 (minutes) or 1.5 (hours)",
  "time.form.durationInvalid": "Enter between 1 minute and 24 hours, for example 1:30.",
  "time.form.date": "Day",
  "time.form.note": "Note",
  "time.form.notePlaceholder": "What did you work on?",
  "time.form.billable": "Billable to the client",
  "time.entry.nonBillable": "Not billable",
  "time.entry.edit": "Edit entry",
  "time.entry.delete": "Delete entry",
  "time.entry.save": "Save",
  "time.entry.deleteTitle": "Delete this time entry?",
  "time.entry.deleteBody": "{duration} will be removed from the task and from your timesheet.",
  "time.estimate.of": "of {estimate} estimated",
  "time.estimate.none": "logged · no estimate",
  "time.estimate.left": "{duration} left",
  "time.estimate.over": "{duration} over",
  "time.estimate.progress": "{logged} of {estimate} estimated",
  "time.estimate.loggedOnly": "{logged} logged",
  "time.task.title": "Time",
  "time.task.log": "Log time",
  "time.task.logSubmit": "Log time",
  "time.task.logged": "Logged {duration}",
  "time.task.mine": "Your time: {duration}",
  "time.task.byPerson": "Time by person",
  "time.task.empty": "No time logged yet. Start the timer or log time by hand.",
  "time.task.emptyReadOnly": "No time logged on this task yet.",
  "time.task.loadError": "We could not load the time on this task.",
  "time.task.showAll": "{count, plural, one {Show # entry} other {Show all # entries}}",
  "time.task.showFewer": "Show fewer",
  "time.project.title": "Time",
  "time.project.billableShare": "{share} of it billable",
  "time.project.thisWeek": "This week",
  "time.project.billable": "Billable",
  "time.project.estimateVsActual": "Estimate vs actual, on estimated tasks",
  "time.project.topPeople": "Most time logged",
  "time.project.yourTime": "Your time",
  "time.project.empty": "No time logged on this project yet.",
  "time.project.openTimesheet": "Open your timesheet",
  "time.project.loadError": "We could not load this project's time.",
  "time.log.open": "Log time",
  "time.log.title": "Log time",
  "time.log.description": "Add time you spent without the timer.",
  "time.log.target": "Task or project",
  "time.log.targetMissing": "Choose a task or project.",
  "time.log.submit": "Log time",
  "time.log.done": "Logged {duration}",
  "time.sheet.title": "Timesheet",
  "time.sheet.titleOf": "Timesheet: {name}",
  "time.sheet.subtitle": "Your week, Sunday to Saturday. Type minutes or h:mm into a day; it saves when you leave the cell.",
  "time.sheet.weekNav": "Week",
  "time.sheet.previousWeek": "Previous week",
  "time.sheet.nextWeek": "Next week",
  "time.sheet.thisWeek": "This week",
  "time.sheet.weekRange": "{start} – {end}",
  "time.sheet.targetLabel": "{logged} of the {target} weekly target",
  "time.sheet.targetOf": "of {target} · {percent}",
  "time.sheet.billable": "billable · {share}",
  "time.sheet.caption": "Timesheet of {name}",
  "time.sheet.workColumn": "Task",
  "time.sheet.totalColumn": "Total",
  "time.sheet.dayTotals": "Total",
  "time.sheet.cellLabel": "{title}, {date}",
  "time.sheet.cellInvalid": "Type minutes (90) or hours and minutes (1:30), up to 24 hours.",
  "time.sheet.addRow": "Add a row",
  "time.sheet.addRowPlaceholder": "Add a task or project to this week…",
  "time.sheet.today": "Today",
  "time.sheet.dayEmpty": "No time",
  "time.sheet.weekend": "Weekend",
  "time.sheet.empty.title": "No time this week yet",
  "time.sheet.empty.body": "Start a timer above, log time by hand, or add a row and type into a day.",
  "time.sheet.emptyOther.title": "No time this week",
  "time.sheet.emptyOther.body": "{name} has no time this week that you can see.",
  "time.sheet.person": "Whose timesheet",
  "time.sheet.choosePerson": "Choose a person",
  "time.sheet.searchPeople": "Search people",
  "time.sheet.noPeople": "No one matches",
  "time.report.title": "Time reports",
  "time.report.subtitle": "Where the time went, {start} – {end}.",
  "time.report.export": "Export CSV",
  "time.report.range": "Range",
  "time.report.preset.this-week": "This week",
  "time.report.preset.last-week": "Last week",
  "time.report.preset.this-month": "This month",
  "time.report.preset.last-month": "Last month",
  "time.report.preset.custom": "Custom",
  "time.report.from": "From",
  "time.report.to": "To",
  "time.report.groupBy": "Group by",
  "time.report.group.project": "Project",
  "time.report.group.person": "Person",
  "time.report.group.client": "Client",
  "time.report.group.task": "Task",
  "time.report.internal": "No client (internal)",
  "time.report.noTask": "Project work (no task)",
  "time.report.unnamed": "Unnamed",
  "time.report.other": "Other",
  "time.report.summary.total": "Total time",
  "time.report.summary.billable": "Billable time",
  "time.report.summary.nonBillable": "{duration} not billable",
  "time.report.summary.share": "Billable share",
  "time.report.scope.everyone": "Everyone's time",
  "time.report.scope.yours": "Your time, and the projects you lead",
  "time.report.chartTitle": "Breakdown",
  "time.report.legend.billable": "Billable",
  "time.report.legend.nonBillable": "Not billable",
  "time.report.tooltip": "{total} · {billable} billable · {share}",
  "time.report.tableCaption": "Time by group, with billable time and share",
  "time.report.columns.time": "Time",
  "time.report.columns.billable": "Billable",
  "time.report.columns.share": "Share",
  "time.report.total": "Total",
  "time.report.csv.code": "Code",
  "time.report.csv.context": "Project",
  "time.report.csv.hours": "Hours",
  "time.report.csv.billableHours": "Billable hours",
  "time.report.csv.share": "Share (%)",
  "time.report.empty.title": "No time in this range",
  "time.report.empty.body": "Pick another range, or log time from your timesheet.",
  "time.errors.future": "That time has not happened yet. Log it once it has passed.",
  "time.errors.tooOld": "Time older than 60 days is closed. Ask the project lead to change it.",
  "time.errors.length": "An entry lasts between 1 minute and 24 hours.",
  "time.errors.running": "Stop the timer before changing how long it ran.",
  "time.errors.archived": "This project is archived, so time can no longer be logged on it.",
  "time.errors.notRunning": "No timer is running.",
  "time.errors.alreadyRunning": "Another timer just started. Reload and try again.",
  "time.errors.range": "Choose a start on or before the end, at most a year apart.",
  "time.errors.forbidden": "You cannot log time on this project.",
  "time.errors.notFound": "We could not find that. It may have been removed.",
  "time.errors.generic": "Something went wrong with your time. Try again.",
  "time.sheet.you": "You",
  "time.sheet.byProject.title": "This week by project",
  "time.sheet.byProject.body": "Where the week's time went"
}
